/**
 * Build stage indicator. Updated by hand at the start of each stage so
 * the deployed /health endpoint reports the current state of the world.
 */
export const STAGE = 0;
export const STAGE_LABEL = 'Stage 0: Hosting and deploy pipeline';
//# sourceMappingURL=stage.js.map